import React from 'react'
import PropTypes from 'prop-types'
import {Spin} from "antd"
import ItemErrorRows from "./ItemErrorRows"

ItemErrorTable.propTypes = {
    loading: PropTypes.bool,
    items: PropTypes.array,
    onChangeProductType: PropTypes.func.isRequired,
}

function ItemErrorTable(props) {
    const {
        loading,
        items,
        onChangeProductType
    } = props

    return (
        <div className='ItemErrorTable'>
            <Spin spinning={loading} tip='Đang tải...'>
                <table className='table table-borderless table-striped'>
                    <thead className='thead-light'>
                    <tr>
                        <th className='Barcode'>Barcode</th>
                        <th className="Sku">SKU</th>
                        <th className="Size">Size</th>
                        <th className="BatchName">Tên lô</th>
                        <th className="DateError">Ngày báo lỗi</th>
                        {/* <th className="ErrorStyle">Kiểu lỗi</th> */}
                        <th className="ErrorType">Loại lỗi</th>
                        <th className="ErrorDetail">Chi tiết lỗi</th>
                        <th className="Quantity text-center">Số lượng chi tiết bù</th>
                        <th className="PartnerPrint">Đối tác in ép</th>
                        <th className="PartnerSewing">Đối tác may</th>
                        <th className="printer">Máy in</th>
                        <th className="presser">Máy cắt</th>
                        <th className="material_vendor">Nhà cung cấp vải</th>
                        <th className="import_date">Ngày nhập vải</th>
                        <th className="DateError">Người báo lỗi</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        !!items && items.length > 0 ? (
                            items.map(item => {
                                    return (
                                        <ItemErrorRows
                                            key={item._id}
                                            item={item}
                                            onChangeProductType={onChangeProductType}
                                        />
                                    )
                                }
                            )
                        ) : (
                            <tr>
                                <td colSpan={16}>No data</td>
                            </tr>
                        )
                    }
                    </tbody>
                </table>
            </Spin>
        </div>
    )
}

export default ItemErrorTable